export enum BusinessSelectTab {
  MYBUSINESS = "myBusiness",
  WORKPLACES = "workPlaces",
}
